//API imports
import { httpGet } from '../api/httpGet';
import { httpPost } from '../api/httpPost';
import { httpPut } from '../api/httpPut';
import { httpDelete } from '../api/httpDelete';

export const actions = {

  /////////////////////////////////////////////////////////
  //Actions For Updating API 
  /////////////////////////////////////////////////////////

  syncStoreWithDatabaseAfterComingOnline: context => {
    //Write Code to Sync Offline changes With API Here
  },
  makeChangesToAPI: (context, mutationType) => {

    if (mutationType === 'initialiseStore') {
      context.dispatch('getDataFromAPIIfNeeded');
    }
    else if (mutationType.substring(0, 3) === 'add') {
      context.dispatch('addDataForAPIIfNeeded', mutationType)
    }
    else if (mutationType.substring(0, 6) === 'update') {
      context.dispatch('updateDataForAPIIfNeeded', mutationType)
    }
    else if (mutationType.substring(0, 4) === 'mark') {
      context.dispatch('deleteDataFromAPIIfNeeded', mutationType)
    }

  },

  ///GET DATA

  getDataFromAPIIfNeeded: context => {
    //Gets Data from Account If Needed
    context.dispatch('getDataFromAccountIfNeeded')

    //Gets Data from Income If Needed
    context.dispatch('getDataFromIncomeIfNeeded')

    //Get Data from Expense If Needed
    context.dispatch('getDataFromExpenseIfNeeded')
  },

  getDataFromAccountIfNeeded: context => {
    if (context.state.Accounts.length === 0) {
      context.dispatch('getAccountDataFromAPI')
    }
  },
  getDataFromIncomeIfNeeded: context => {
    if (context.state.Incomes.length === 0) {
      context.dispatch('getIncomeDataFromAPI')
    }
  },
  getDataFromExpenseIfNeeded: context => {
    if (context.state.Expenses.length === 0) {
      context.dispatch('getExpenseDataFromAPI')
    }
  },
  getDataFromBudgetIfNeeded: context => {
    if (context.state.Budgets.length === 0) {
      context.dispatch('getBudgetDataFromAPI')
    }
  },
  
  ///END OF GET DATA

  ///ADD DATA

  addDataForAPIIfNeeded: (context, mutationType) => {
    
    if (mutationType.indexOf("Account") !== -1) {
    //Gets Data from Account If Needed
      context.dispatch('addDataForAccountIfNeeded')
    }
    else if (mutationType.indexOf("Income") !== -1) {
      //Gets Data from Income If Needed
      context.dispatch('addDataForIncomeIfNeeded')
    }
    else if (mutationType.indexOf("Expense") !== -1) {
      //Gets Data from Expense If Needed
      context.dispatch('addDataForExpenseIfNeeded')
    }
    else if (mutationType.indexOf("Budget") !== -1) {
      //Gets Data from Expense If Needed
      context.dispatch('addDataForBudgetIfNeeded')
    }

  },

  addDataForAccountIfNeeded: context => {
    let newAccounts = []

    for (let i = 0; i < context.state.Accounts.length; i++) {
      if (context.state.Accounts[i].objectState === "New") {
        newAccounts.push(context.state.Accounts[i])
      }
    }

    context.dispatch('addNewAccountToDatabase', newAccounts)

  },
  addDataForIncomeIfNeeded: context => {
    let newIncomes = []

    for (let i = 0; i < context.state.Incomes.length; i++) {
      if (context.state.Incomes[i].objectState === "New") {
        newIncomes.push(context.state.Incomes[i])
      }
    }

    context.dispatch('addNewIncomeToDatabase', newIncomes)

  },
  addDataForExpenseIfNeeded: context => {
    let newExpenses = []

    for (let i = 0; i < context.state.Expenses.length; i++) {
      if (context.state.Expenses[i].objectState === "New") {
        newExpenses.push(context.state.Expenses[i])
      }
    }

    context.dispatch('addNewExpenseToDatabase', newExpenses)

  },
  addDataForBudgetIfNeeded: context => {
    let newBudgets = []

    for (let i = 0; i < context.state.Budgets.length; i++) {
      if (context.state.Budgets[i].objectState === "New") {
        newBudgets.push(context.state.Budgets[i])
      }
    }

    context.dispatch('addNewBudgetToDatabase', newBudgets)

  },


  ///END OF ADD DATA

  //UPDATE DATA

  updateDataForAPIIfNeeded: (context, mutationType) => {

    if (mutationType.indexOf("Account") !== -1) {
      //Gets Data from Account If Needed
      context.dispatch('updateDataForAccountIfNeeded')
    }
    else if (mutationType.indexOf("Income") !== -1) {
      //Gets Data from Income If Needed
      context.dispatch('updateDataForIncomeIfNeeded')
    }
    else if (mutationType.indexOf("Expense") !== -1) {
      //Gets Data from Expense If Needed
      context.dispatch('updateDataForExpenseIfNeeded')
    }
    else if (mutationType.indexOf("Budget") !== -1) {
      //Gets Data from Expense If Needed
      context.dispatch('updateDataForBudgetIfNeeded')
    }

  },

  updateDataForAccountIfNeeded: context => {
    let updateAccounts = []

    for (let i = 0; i < context.state.Accounts.length; i++) {
      if (context.state.Accounts[i].objectState === "Update") {
        updateAccounts.push(context.state.Accounts[i])
      }
    }

    context.dispatch('updateAccountinDatabase', updateAccounts)

  },
  updateDataForIncomeIfNeeded: context => {
    let updateIncomes = []

    for (let i = 0; i < context.state.Incomes.length; i++) {
      if (context.state.Incomes[i].objectState === "Update") {
        updateIncomes.push(context.state.Incomes[i])
      }
    }

    context.dispatch('updateIncomeInDatabase', updateIncomes)

  },
  updateDataForExpenseIfNeeded: context => {
    let updateExpenses = []

    for (let i = 0; i < context.state.Expenses.length; i++) {
      if (context.state.Expenses[i].objectState === "Update") {
        updateExpenses.push(context.state.Expenses[i])
      }
    }

    context.dispatch('updateExpenseInDatabase', updateExpenses)

  },
  updateDataForBudgetIfNeeded: context => {
    let updateBudgets = []

    for (let i = 0; i < context.state.Budgets.length; i++) {
      if (context.state.Budgets[i].objectState === "Update") {
        updateBudgets.push(context.state.Budgets[i])
      }
    }

    context.dispatch('updateBudgetInDatabase', updateBudgets)

  },

  //END OF UPDATE DATA

  //DELETE DATA

  deleteDataFromAPIIfNeeded: (context, mutationType) => {
    if (mutationType.indexOf("Account") !== -1) {
      //Gets Data from Account If Needed
      context.dispatch('deleteDataForAccountIfNeeded')
    }
    else if (mutationType.indexOf("Income") !== -1) {
      //Gets Data from Income If Needed
      context.dispatch('deleteDataForIncomeIfNeeded')
    }
    else if (mutationType.indexOf("Expense") !== -1) {
      //Gets Data from Expense If Needed
      context.dispatch('deleteDataForExpenseIfNeeded')
    }

  },

  deleteDataForAccountIfNeeded: context => {
    let deleteAccounts = []

    for (let i = 0; i < context.state.Accounts.length; i++) {
      if (context.state.Accounts[i].objectState === "Delete") {
        deleteAccounts.push(context.state.Accounts[i])
      }
    }

    context.dispatch('deleteAccountinDatabase', deleteAccounts)

  },
  deleteDataForIncomeIfNeeded: context => {
    let deleteIncomes = []

    for (let i = 0; i < context.state.Incomes.length; i++) {
      if (context.state.Incomes[i].objectState === "Delete") {
        deleteIncomes.push(context.state.Incomes[i])
      }
    }

    context.dispatch('deleteIncomeInDatabase', deleteIncomes)

  },
  deleteDataForExpenseIfNeeded: context => {
    let deleteExpenses = []

    for (let i = 0; i < context.state.Expenses.length; i++) {
      if (context.state.Expenses[i].objectState === "Delete") {
        deleteExpenses.push(context.state.Expenses[i])
      }
    }

    context.dispatch('deleteExpenseinDatabase', deleteExpenses)

  },

  //END OF DELETE DATA

  /////////////////// //////////////////////////////////////
  //End Of Actions For Updating API 
  /////////////////////////////////////////////////////////


  /////////////////////////////////////////////////////////
  //Account Actions
  /////////////////////////////////////////////////////////

  getAccountDataFromAPI: context => {

    let p1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      (resolve, reject) => {
        httpGet.getAccounts(function (data) {
          context.commit('updateStoreWithAccountsDataFromAPI', data)
        })
      });
  },
  addNewAccountToDatabase: (context, accountData) => {
    //context.commit('addNewAccountToStore', accountData)

    for (let i = 0; i < accountData.length; i++) {
      let a1 = new Promise(
        // The resolver function is called with the ability to resolve or reject the promise
        (resolve, reject) => {
          httpPost.postNewAccount(accountData[i], function (data) {
            for (let j = 0; j < context.state.Accounts.length; j++) {
              if (context.state.Accounts[j].accountName === accountData[i].accountName) {
                context.state.Accounts[j].id = data
                context.state.Accounts[j].objectState = "Current"
              }
            }
          })
        });
    }
    
  },
  updateAccountinDatabase: (context, accountData) => {
    //context.commit('updateAccountinStore', accountData)

    for (let i = 0; i < accountData.length; i++) {
      let u1 = new Promise(
        // The resolver function is called with the ability to resolve or reject the promise
        (resolve, reject) => {
          httpPut.updateAccount(accountData[i], function (data) {
            if (data === 200) {
              for (let j = 0; j < context.state.Accounts.length; j++) {
                if (context.state.Accounts[j].id === accountData[i].id) {
                  //context.state.Accounts[j].id = data
                  context.state.Accounts[j].objectState = "Current"
                }
              }
            }
          })
        });
    }

  },
  deleteAccountinDatabase: (context, accountData) => {
    //context.commit('updateAccountinStore', accountData)

    for (let i = 0; i < accountData.length; i++) {
      let d1 = new Promise(
        // The resolver function is called with the ability to resolve or
        // reject the promise
        (resolve, reject) => {
          httpDelete.deleteAccount(accountData[i], function (data) {
            if (data === 200) {
              context.commit('deleteAccountfromStore', accountData[i])
            }
          })
        });
    }
  },

  /////////////////////////////////////////////////////////
  //End Of Account Actions
  /////////////////////////////////////////////////////////


  /////////////////////////////////////////////////////////
  //Income Actions
  /////////////////////////////////////////////////////////

  getIncomeDataFromAPI: context => {
    let p1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      (resolve, reject) => {
        httpGet.getIncomes(function (data) {
          context.commit('updateStoreWithIncomeDataFromAPI', data)
        })
      });
  },
  addNewIncomeToDatabase: (context, incomeData) => {
    //context.commit('addNewIncomeToStore', incomeData)

    for (let i = 0; i < incomeData.length; i++) {
      let a1 = new Promise(
        // The resolver function is called with the ability to resolve or
        // reject the promise
        (resolve, reject) => {
          httpPost.postNewIncome(incomeData, function (data) {
            for (let j = 0; j < context.state.Incomes.length; j++) {
              if (context.state.Incomes[j].incomeName === incomeData[i].incomeName) {
                context.state.Incomes[j].id = data
                context.state.Incomes[j].objectState = "Current"
              }
            }
          })
        });
    }
  },
  updateIncomeInDatabase: (context, incomeData) => {
    //context.commit('updateIncomeinStore', incomeData)

    for (let i = 0; i < incomeData.length; i++) {
      let u1 = new Promise(
        // The resolver function is called with the ability to resolve or
        // reject the promise
        (resolve, reject) => {
          httpPut.updateIncome(incomeData, function (data) {
            if (data === 200) {
              for (let j = 0; j < context.state.Incomes.length; j++) {
                if (context.state.Incomes[j].id === incomeData[i].id) {
                  context.state.Incomes[j].objectState = "Current"
                }
              }
            }
          })
        });
    }

  },
  deleteIncomeInDatabase: (context, incomeData) => {
    //context.commit('updateIncomeinStore', incomeData)

    for (let i = 0; i < incomeData.length; i++) {
      let d1 = new Promise(
        // The resolver function is called with the ability to resolve or
        // reject the promise
        (resolve, reject) => {
          httpDelete.deleteIncome(incomeData, function (data) {
            if (data === 200) {
              context.commit('deleteIncomefromStore', incomeData)
            }
          })
        });
    }
  },

  /////////////////////////////////////////////////////////
  //End Of Income Actions
  /////////////////////////////////////////////////////////


  /////////////////////////////////////////////////////////
  //Expense Actions
  /////////////////////////////////////////////////////////

  getExpenseDataFromAPI: context => {
    let p1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      (resolve, reject) => {
        httpGet.getExpenses(function (data) {
          context.commit('updateStoreWithExpenseDataFromAPI', data)
        })
      });
  },
  addNewExpenseToDatabase: (context, expenseData) => {
    //context.commit('addNewExpenseToStore', expenseData)

    for (let i = 0; i < expenseData.length; i++) {
      let a1 = new Promise(
        // The resolver function is called with the ability to resolve or
        // reject the promise
        (resolve, reject) => {
          httpPost.postNewExpense(expenseData, function (data) {
            for (let j = 0; j < context.state.Expenses.length; j++) {
              if (context.state.Expenses[j].expenseName === expenseData[i].expenseName) {
                context.state.Expenses[j].id = data
                context.state.Expenses[j].objectState = "Current"
              }
            }
          })
        });
    }
  },
  updateExpenseInDatabase: (context, expenseData) => {
    //context.commit('updateExpenseinStore', expenseData)

    for (let i = 0; i < expenseData.length; i++) {
      let u1 = new Promise(
        // The resolver function is called with the ability to resolve or
        // reject the promise
        (resolve, reject) => {
          httpPut.updateExpense(expenseData, function (data) {
            if (data === 200) {
              for (let j = 0; j < context.state.Expenses.length; j++) {
                if (context.state.Expenses[j].id === expenseData[i].id) {
                  context.state.Expenses[j].objectState = "Current"
                }
              }
            }
          })
        });
    }

  },
  deleteExpenseinDatabase: (context, expenseData) => {

    for (let i = 0; i < expenseData.length; i++) {
      let d1 = new Promise(
        // The resolver function is called with the ability to resolve or
        // reject the promise
        (resolve, reject) => {
          httpDelete.deleteExpense(expenseData, function (data) {
            if (data === 200) {
              context.commit('deleteExpensefromStore', expenseData)
            }
          })
        });
    }
  },

  /////////////////////////////////////////////////////////
  //End Of Expense Actions
  /////////////////////////////////////////////////////////


  /////////////////////////////////////////////////////////
  //Budget Actions
  /////////////////////////////////////////////////////////

  getBudgetDataFromAPI: context => {
    let p1 = new Promise(
      // The resolver function is called with the ability to resolve or
      // reject the promise
      (resolve, reject) => {
        httpGet.getExpenses(function (data) {
          context.commit('updateStoreWithBudgetDataFromAPI', data)
        })
      });
  },
  addNewBudgetToDatabase: (context, budgetData) => {

    for (let i = 0; i < budgetData.length; i++) {
      let a1 = new Promise(
        // The resolver function is called with the ability to resolve or
        // reject the promise
        (resolve, reject) => {
          httpPost.postNewBudget(budgetData, function (data) {
            for (let j = 0; j < context.state.Budgets.length; j++) {
              if (context.state.Budgets[j].budgetName === budgetData[i].budgetName) {
                context.state.Budgets[j].id = data
                context.state.Budgets[j].objectState = "Current"
              }
            }
          })
        });
    }
  },
  updateBudgetInDatabase: (context, budgetData) => {
   
    for (let i = 0; i < budgetData.length; i++) {
      let u1 = new Promise(
        // The resolver function is called with the ability to resolve or
        // reject the promise
        (resolve, reject) => {
          httpPut.updateBudget(budgetData, function (data) {
            if (data === 200) {
              for (let j = 0; j < context.state.Budgets.length; j++) {
                if (context.state.Budgets[j].id === budgetData[i].id) {
                  context.state.Budgets[j].objectState = "Current"
                }
              }
            }
          })
        });
    }

  },
  deleteBudgetinDatabase: (context, budgetData) => {

    for (let i = 0; i < budgetData.length; i++) {
      let d1 = new Promise(
        // The resolver function is called with the ability to resolve or
        // reject the promise
        (resolve, reject) => {
          httpDelete.deleteBudget(budgetData, function (data) {
            if (data === 200) {
              context.commit('deleteBudgetfromStore', budgetData)
            }
          })
        });
    }
  },

  /////////////////////////////////////////////////////////
  //End Of Budget Actions
  /////////////////////////////////////////////////////////



}



// WEBPACK FOOTER //
// ./src/store/actions.js